/**
 * @file store 工具文件
 */
import pinyinDictFirstletter from '@/assets/pinyin_dict_firstletter';
import _ from 'lodash';
import {mark2name, getSourceArray} from '@/util/markUtil';

/**
 * 设置marks分组
 * @param {Array} marks marks响应数据
 * @return {Array} 修改分组数据
 */
export function groupSpider(marks) {
    const markGroup = _.groupBy(marks, 'group');
    let result = [];
    const groupCategorys = ['已知爬虫', '观察', '未知爬虫', '手机', 'PC'];
    Object.keys(markGroup).forEach(key => {
        markGroup[key] = sortReindeer(markGroup[key], 'name', true);
        markGroup[key][0].rowSpan = markGroup[key].length;
    });
    groupCategorys.forEach(category => {
        result = result.concat(markGroup[category] || []);
    });
    return result;
}

/**
 * 初始化分组
 * @param {Array} marks marks数据
 */
export function initMarks(marks) {
    const sourceArray = getSourceArray();
    marks.forEach(item => {
        item.name = mark2name(item.mark);
        if (sourceArray.indexOf(item.name) > -1) {
            item.group = '已知爬虫';
        } else {
            item.group = item.name;
        }
    });
    // marks.push({
    //     group: '观察',
    //     code: 501,
    //     name: '观察',
    //     updateTime: marks[0].updateTime
    // });
}

/**
 * 按照英文首字母、中文首字母字典排序
 * @param {*} arr 数据源
 * @param {*} property 排序属性
 * @param {*} sequence 是否降序
 */
export function sortReindeer(arr, property, sequence) {
    for (let j = 0; j < arr.length - 1; j += 1) {
        // 两两比较，如果前一个比后一个大，则交换位置。
        for (var i = 0; i < arr.length - 1 - j; i += 1) {
            // 取出数组对应属性进行排序
            const before = compareString(arr[i][property], arr[i + 1][property]);
            if (before === 1) {
                const temp = arr[i];
                arr[i] = arr[i + 1];
                arr[i + 1] = temp;
            }
        }
    }
    if (sequence) {
        arr.reverse();
    }
    return arr;
}

// code从-1至1依次是str1排在str2后，相等，前
function compareString(str1, str2) {
    const str1Length = str1.length;
    const str2Length = str2.length;
    const StringLength = Math.min(str1Length, str2Length);
    let StringCode = '';
    let code = 0;
    // 字符串长度短的，排序靠前
    for (let i = 0; i < StringLength; i += 1) {
        StringCode = compareCharacter(str1[i], str2[i]);
        if (StringCode === -1) {
            code = -1;
            break;
        } else if (StringCode === 1) {
            code = 1;
            break;
        } else {
            code = 0;
        }
    }
    if (code === 0 && str1Length !== str2Length) {
        code = str1Length - str2Length <= -1 ? 1 : -1;
    }
    return code;
}

// 单字符排序，优先级：（特殊字符>数字>英文字母>汉字）
function compareCharacter(letter1, letter2) {
    const letter1TypeNum = determineType(letter1);
    const letter2TypeNum = determineType(letter2);
    let before = '';
    let after = '';
    let code = '';
    // 不同类型排序
    if (letter1TypeNum !== letter2TypeNum) {
        code = letter1TypeNum < letter2TypeNum;
        return code ? 1 : -1
    } else {
        // 同类型对比
        if (letter1TypeNum === 0) {
            return 0;
        }

        if (letter1TypeNum === 1) {
            before = letter1;
            after = letter2;
        }
        // 不区分大小写，依据英文字母Unicode码大小排序，a-z的Unicode码依次增加
        if (letter1TypeNum === 2) {
            before = letter1.toLocaleLowerCase().charCodeAt(0);
            after = letter2.toLocaleLowerCase().charCodeAt(0);
        }
        if (letter1TypeNum === 3) {
            // 转换成汉字对应拼音的首字母进行比较
            before = getFirstLetter(letter1).toLocaleLowerCase().charCodeAt(0);
            after = getFirstLetter(letter2).toLocaleLowerCase().charCodeAt(0);
        }
    }
    if (before > after) {
        code = -1;
    } else if (before === after) {
        code = 0;
    } else {
        code = 1;
    }

    return code;
}
// 判断单字符类型，返回值0到3依次是特殊字符，数字，字母，汉字类型
function determineType(Letter) {
    // 判断类型
    const isNum = !isNaN(Letter);
    const isLetter = /[_a-zA-Z]/.test(Letter);
    const isChinese = !/[^\u4E00-\u9FA5]/.test(Letter);
    let typeNum = '';
    if (isLetter) {
        typeNum = 1;
    } else if (isNum) {
        typeNum = 2;
    } else if (isChinese) {
        typeNum = 3;
    } else {
        typeNum = 0;
    }
    return typeNum;
}

// 返回汉字拼音首字母（大写）
function getFirstLetter(str) {
    const funPinyinDictFirstletter = {};
    // 拼音首字母字典文件
    funPinyinDictFirstletter.all = pinyinDictFirstletter;
    const dict = {};
    if (!str || /^ +$/g.test(str)) return '';
    dict.firstletter = funPinyinDictFirstletter;
    if (dict.firstletter) // 使用首字母字典文件
    {
        const result = [];
        for (var i = 0; i < str.length; i++) {
            const unicode = str.charCodeAt(i);
            let ch = str.charAt(i);
            if (unicode >= 19968 && unicode <= 40869) {
                ch = dict.firstletter.all.charAt(unicode - 19968);
            }
            result.push(ch);
        }
        return result.join('');
    }
}